/* app/js/src/components/common/x-button/x-button.component.scss */
.container svg.scale {
  transition: transform 0.2s, -webkit-transform 0.2s;
}
.container svg.scale:hover {
  transform: translate(2px, 0) scale(1.4);
}
/*# sourceMappingURL=x-button.component.css.map */
